import classNames from 'classnames';
import type { CSSProperties } from 'react';

export const TAURI_INTERACTIVE_OVERLAY_CLASS = 'tauri-no-drag';
export const TAURI_JS_DRAG_REGION_CLASS = 'tauri-js-drag-region';

type TauriNoDragStyle = CSSProperties & {
  WebkitAppRegion?: 'no-drag';
};

export const TAURI_NO_DRAG_STYLE = {
  pointerEvents: 'auto',
  WebkitAppRegion: 'no-drag',
} as TauriNoDragStyle;

export const TAURI_INTERACTIVE_OVERLAY_STYLE = {
  ...TAURI_NO_DRAG_STYLE,
  zIndex: 2147483000,
} as TauriNoDragStyle;

export const isTauriInteractiveOverlayEnabled = () => Boolean(window.__TAURI__);

export const getTauriNoDragClassName = (className?: string, enabled = isTauriInteractiveOverlayEnabled()) =>
  enabled ? classNames(TAURI_INTERACTIVE_OVERLAY_CLASS, className) : className;

export const getTauriNoDragStyle = (
  style?: CSSProperties,
  enabled = isTauriInteractiveOverlayEnabled()
): CSSProperties | TauriNoDragStyle | undefined =>
  enabled
    ? {
        ...TAURI_NO_DRAG_STYLE,
        ...style,
      }
    : style;

export const getTauriInteractiveOverlayClassName = getTauriNoDragClassName;

export const getTauriInteractiveOverlayStyle = (
  style?: CSSProperties,
  enabled = isTauriInteractiveOverlayEnabled()
): CSSProperties | TauriNoDragStyle | undefined =>
  enabled
    ? {
        ...TAURI_INTERACTIVE_OVERLAY_STYLE,
        ...style,
      }
    : style;
